import type { WidgetFullModeProps } from '@/entities/widget';
import { SPECIAL_AGENT_IDS, useAgentCategoryChipColor } from '@/entities/agent';
import LightbulbOutlinedGreyIcon from '@/shared/assets/images/LightbulbOutlinedGrey.svg';
import { CenteredContent } from '@/shared/ui/layout/CenteredContent';
import { SidePanel } from '@/shared/ui/SidePanelWrapper';
import type { BehindTheAnswerWidgetProps } from '../model/audience-flow-widget.types';
import { CaresAboutSection } from './components/CaresAboutSection';
import { MainTakeAwaySection } from './components/MainTakeAwaySection';
import { SourcesSection } from './components/SourcesSection';
import { useTranslation } from 'react-i18next';
import { personaLabel } from '@/shared/lib/persona-label';

export const BehindTheAnswerWidget = (props: WidgetFullModeProps<BehindTheAnswerWidgetProps>) => {
  const { t } = useTranslation('audiences');
  const categoryChipColor = useAgentCategoryChipColor(SPECIAL_AGENT_IDS.AUDIENCE_FLOW);

  const { data } = props;

  const label = personaLabel(data, ', ');

  return (
    <SidePanel
      title={t('audienceFlowWidget.behindTheAnswerWidget.interview', { persona: label })}
      headerConfig={{
        chip: {
          label: t('audienceFlowWidget.behindTheAnswerWidget.dataBehindTheAnswer'),
          color: categoryChipColor,
        },
      }}
    >
      <div className="w-full space-y-10 border-t border-black/5">
        <CenteredContent>
          <MainTakeAwaySection mainTakeAway={data.mainTakeAway} />
          <CaresAboutSection
            caresAbout={data.caresAbout ?? []}
            title={t('audienceFlowWidget.behindTheAnswerWidget.basedOnWhatPersonaCares')}
            icon={LightbulbOutlinedGreyIcon}
          />
          <SourcesSection sources={data.sources} />
        </CenteredContent>
      </div>
    </SidePanel>
  );
};
